<div class="w-full h-full" id="screen-preview" [class.hidden]="!isScreenSharing()"></div>
<div class="w-full h-full" id="remote-screen" [class.hidden]="!isRemoteSharing()"></div>
<div class="flex justify-between items-center absolute bottom-3 gap-1 left-4 right-4 z-10">
  <div class="flex text-white text-sm items-center gap-1 min-w-0">
    @if (sharingMicOn()) {
      <app-sound-icon [volume]="sharingSoundLevel()"></app-sound-icon>
    }
    <span class="flex-1 min-w-0 truncate">
      {{ isScreenSharing() ? 'Bạn' : (participant()?.userName ?? 'Đối phương') }}
    </span>

    <span class="shrink-0">| Đang trình chiếu</span>
  </div>
  @if (isScreenSharing()) {
    <button
      class="glass-button rounded-full h-8 font-semibold text-xs min-w-[100px]"
      (click)="stopShare.emit()"
    >
      Dừng chia sẻ
    </button>
  }
  <button
    class="glass-button rounded-full w-8 h-8 shrink-0 flex items-center justify-center"
    (click)="toggleFullScreen.emit()"
  >
    <app-icon
      [name]="
        isFullScreenShare() ? 'meeting/close-fullscreen-icon' : 'meeting/open-fullscreen-icon'
      "
      [size]="16"
    />
  </button>
</div>
